<template>
  <div class="mb-4">
    <!--#region -- Content ---->
    <!--#region ETO Sector SKU  Data-->
    <div class="">
      <div class="caption-label d-flex">
        <div>
          <b-badge style="margin-right: 10px;"
                   v-if="etoSectorSkuInfo && etoSectorSkuInfo.length > 0"
                   variant="primary">
            {{etoSectorSkuInfo.length}}
          </b-badge>
          ETO Sector SKU
        </div>
      </div>
      <!-- REGION: TABLE FOR ETO SECTOR SKU LIST -->
      <div style="padding-top: 10px;"
           v-if="etoSectorSkuInfo && etoSectorSkuInfo.length > 0">
        <b-table :fields="etoSectorSkuFields" :items="etoSectorSkuInfo"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(pn_set)="data">
            <div v-if="data.item.pn_set === null || _.size(data.item.pn_set) === 0">
              <div class="row mb-2">
                <div class="col-2">
                  <div>MPS</div>
                  <div>SHIP</div>
                </div>
                <div class="col-8">
                  <div>: </div>
                  <div>: </div>
                </div>
                <div class="col-2">
                  <div v-if="actionEnable">
                    <button type="button"
                            class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                            style="margin-top: 0.5rem; margin-left: -1.5rem;"
                            @click="showPnModal(data.item)">
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row mb-2">
                <div class="col-2">
                  <div>MPS</div>
                  <div>SHIP</div>
                </div>
                <div class="col-8">
                  <div>: {{ data.item.pn_set.mps_pn }}</div>
                  <div>: {{ data.item.pn_set.ship_pn }}</div>
                </div>
                <div class="col-2">
                  <div v-if="actionEnable">
                    <button type="button"
                            class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                            style="margin-top: 0.5rem; margin-left: -1.5rem;"
                            @click="showPnModal(data.item)">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template #cell(remark)="data">
            <div>
              <div class="row mb">
                <div class="col">
                  <div>{{ data.item.remark }}</div>
                </div>
                <div class="col-1" style="margin-right: 1rem;" v-if="actionEnable">
                  <button type="button"
                          class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                          style="margin-top: 0.5rem;"
                          @click="showLimitaionModal(data.item)">
                  </button>

                </div>
              </div>
            </div>
          </template>
          <template #cell(document)="data">
            <div>
              <div class="row mb">
                <div class="col">
                  <div v-if="data.item.document !== null && data.item.document !== ''">
                    <b-link :href="safeUrl(data.item.document)">Link to SharePoint</b-link>
                  </div>
                  <div v-else>{{ data.item.document }}</div>
                </div>
                <div class="col-1" style="margin-right: 1rem; margin-top: -1rem" v-if="actionEnable">
                  <button type="button"
                          class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                          style="margin-top: 1rem;"
                          @click="showDocumentModal(data.item)">
                  </button>

                </div>
              </div>
            </div>
          </template>


        </b-table>
      </div>
      <div v-if="etoSectorSkuInfo.length === 0" style="padding-top: 10px;">
        <b-alert show variant="primary">
          There is no NRE initiated for this ETO Sector SKU type of ticket.
          Please notify ES PM to create an NRE and then the section for this ETO Sector SKU will be activated.
        </b-alert>
      </div>
      <!-- END REGION -->
      <!-- region: model for maintain P/N -->
      <b-modal centered
               ok-title="Save"
               @ok="updateETOSectorSku(pnModalData)"
               ref="etoSectorSkuPnModal"
               title="Add/Edit PN for ETO Sector SKU"
               button-size="sm">
        <div style="padding-top: 1rem;"
             v-if="pnModalData && pnModalData.shippedPnToSync
                     && (pnModalData.shippedPnToSync === ''
           || pnModalData.shippedPnToSync === 'N/A')">
          <span>Please add P/Ns for the following.</span>
          <br />
        </div>
        <div class="header-col">
          <div class="col-6"><b>MPS P/N</b><span class="text-danger pl-1">*</span></div>
          <div>
            <gtc-text-box :readOnly="false" class="form-control form-control-sm" required
                          v-model="pnModalData.mpsPnToSyncNew" />
            <div class="invalid-feedback">
              {{ _.get(pnModalData, 'mpsPnToSyncNew', '') == '' ? 'Please enter P/N accordingly' : 'Please enter P/N accordingly.'  }}
            </div>
          </div>
        </div>
        <div class="header-col">
          <div class="col-6"><b>SHIP P/N</b><span class="text-danger pl-1">*</span></div>
          <!--v-if="mpsShipTaaPnModal && mpsShipTaaPnModal.customShipPn"-->
          <div>
            <gtc-text-box :readOnly="false" class="form-control form-control-sm" required
                          v-model="pnModalData.shippedPnToSyncNew" />
            <div class="invalid-feedback">
              {{ _.get(pnModalData, 'shippedPnToSyncNew', '') == '' ? 'Please enter P/N accordingly' : 'Please enter P/N accordingly.'  }}
            </div>
          </div>
        </div>

        <div v-if="etoSectorSkuPnWarning !== null" class="row mb-2">
          <div class="col-12">
            <b class="text-danger pl-1">{{etoSectorSkuPnWarning}}</b>
          </div>
        </div>
      </b-modal>
      <!-- end region -->
      <!-- region: model for maintain Conditions & Limitations -->
      <b-modal centered
               ok-title="Save"
               @ok="validate(remarkModalData) && updateETOSectorSku(remarkModalData)"
               ref="etoSectorSkuLimitations"
               title="Add/Edit Limitations for ETO Sector SKU"
               button-size="sm">

        <div class="header-col">
          <div class="col-3"><b>Conditions & Limitations</b></div>
          <div class="col">
            <textarea class="w-100" v-model="remarkModalData.remarkToSyncNew"></textarea>
            <div v-if="remarkModalData.remarkToSyncNew !== null"
                 :class="classObject(remarkModalData.remarkToSyncNew, 300)">
              <span>You've input: {{ remarkModalData.remarkToSyncNew | getInputLength }}/300</span>
            </div>

          </div>
        </div>
      </b-modal>

      <!-- end region -->
      <!-- region: model for maintain Document/Brochure Link -->
      <b-modal centered
               ok-title="Save"
               @ok="validate(documentModalData) && updateETOSectorSku(documentModalData)"
               ref="etoSectorSkuDocument"
               title="Add/Edit Document Link for ETO Sector SKU"
               button-size="sm">

        <div class="header-col">
          <div class="col-3"><b>Document Link</b></div>
          <div class="col">
            <textarea class="w-100" v-model="documentModalData.documentToSyncNew"></textarea>
            <div v-if="documentModalData.documentToSyncNew !== null"
                 :class="classObject(documentModalData.documentToSyncNew, 800)">
              <span>You've input: {{ documentModalData.documentToSyncNew | getInputLength }}/800</span>
            </div>

          </div>
        </div>
      </b-modal>
      <!-- end region -->
    </div>
  </div>

  <!--#endregion-->
  <!-- END REGION: sku info -->

</template>

<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'eto-sector-sku',
    props: {
      prop_eto_sector_sku_info: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_page_obj: {
        default: null
      },
    },
    data: function () {
      return {
        isRouterAlive: true,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        etoSectorSkuInfo: null,
        ftiePageObj: null,
        loginUser: null,
        userSites: null,
        actionEnable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        ftieId: encodeURIComponent(this.$route.params.ftie_id),
        createBy: null,
        groOwner: null,
        realSkuNo: null,

        searching: false,
        maintianPnHint: '* Please maintain PN first!',
        noneSelectedHint: 'None Selected',
        etoSectorSkuFields: [
          { key: 'nre_id', label: 'NRE ID', thClass: 'align-middle', sortable: true },
          {
            key: 'nre_status', label: 'Progress', thClass: 'align-middle',
            tdClass: 'min-w-187',
            sortable: true
          },
          {
            key: 'sku_id', label: 'Ref SKU(STD)', thClass: 'align-middle',
            tdClass: 'min-w-187',
            sortable: true
          },
          //{ key: 'model_name', label: 'Model', thClass: 'align-middle', sortable: true },
          {
            key: 'pn_set', label: 'SHIP PN as SKU',
            thClass: 'align-middle',
            tdClass: 'min-w-187',
            sortable: true
          },
          {
            key: 'remark', label: 'Limitations',
            thClass: 'align-middle',
            thStyle: {
              'width': '48rem !important',
            },
            sortable: false
          },
          {
            key: 'document', label: 'Brochure Link',
            thClass: 'align-middle',
            thStyle: {
              'width': '28rem !important',
            },
            sortable: false
          }
        ],
        reloadBusy: false,
        processedIndex: [],
        etoSectorSkuPnWarning: null,
        pnModalData: {
          nreId: null,
          field: 'pn',
          itemObj: null,
          shippedPnToSyncNew: null,
          shippedPnToSync: null,
          mpsPnToSyncNew: null,
          mpsPnToSync: null,
        },
        remarkModalData: {
          nreId: null,
          field: 'remark',
          remarkToSyncNew: null,
          remarkToSync: null,
        },
        documentModalData: {
          nreId: null,
          field: 'document',
          documentToSyncNew: null,
          documentToSync: null,
        },
      }
    },
    computed: {
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      }
    },
    created() {
      let self = this;
      self.etoSectorSkuInfo = JSON.parse(JSON.stringify(self.prop_eto_sector_sku_info)); //self.prop_eto_sector_sku_info;
      console.log("etoSectorSkuInfo created");
      console.log(self.etoSectorSkuInfo);
      self.ftiePageObj = self.prop_page_obj;
      self.createBy = _.get(self.ftiePageObj, 'gtc_owner', null);
      self.groOwner = _.get(self.ftiePageObj, 'gro_owner', null);
      // self.userSites = self.prop_user_sites;
      self.loginUser = self.prop_user;
      self.actionEnable = self.checkActionEnable();
      console.log("SFDC Copo actionEnable:");
      console.log(self.actionEnable);
    },
    methods: {
      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },
      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }

        if (self.loginUser !== null && self.groOwner !== null && self.loginUser === self.groOwner) {
          return true;
        }

        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        return false;
      },

      /* region: Document, Brochure Link */
      showDocumentModal(item) {
        let self = this;
        if (item !== null) {
          _.set(self.documentModalData, 'nreId', item.nre_id);
          _.set(self.documentModalData, 'documentToSync', item.document);
          _.set(self.documentModalData, 'documentToSyncNew', item.document);
        }
        self.$refs['etoSectorSkuDocument'].show();

      },
      /* endregion */

      /* region: Limitation */
      showLimitaionModal(item) {
        let self = this;
        if (item !== null) {
          // self.etoSectorSkuRemark = item.remark;
          _.set(self.remarkModalData, 'nreId', item.nre_id);
          _.set(self.remarkModalData, 'remarkToSync', item.remark);
          _.set(self.remarkModalData, 'remarkToSyncNew', item.remark);
        }

        self.$refs['etoSectorSkuLimitations'].show();
      },
      /* endregion */

      /* region: PN sync*/
      showPnModal(item) {
        let self = this;
        if (item && item.pn_set && _.size(item.pn_set) > 0) {
          _.set(self.pnModalData, 'itemObj', JSON.parse(JSON.stringify(item.pn_set)));
        }
        _.set(self.pnModalData, 'nreId', item.nre_id);
        _.set(self.pnModalData, 'shippedPnToSync', item.pn_set.ship_pn);
        _.set(self.pnModalData, 'mpsPnToSync', item.pn_set.mps_pn);
        _.set(self.pnModalData, 'shippedPnToSyncNew', item.pn_set.ship_pn);
        _.set(self.pnModalData, 'mpsPnToSyncNew', item.pn_set.mps_pn);
        self.$refs['etoSectorSkuPnModal'].show();
      },

      reloadEtoSectorSku() {
        let self = this;
        let requestData = {
          create_by: self.loginUser,
          username: self.loginUser,
          ftie_id: self.ftieId,
        };
        self.searching = true;
        //eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/eto-sector-sku/info/', requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'eto_sector_sku_list', null) !== null &&
              _.size(_.get(result, 'eto_sector_sku_list', new Array())) > 0) {
              result.eto_sector_sku_list = JSON.parse(result.eto_sector_sku_list);
            }
            console.log("result.eto_sector_sku_list::");
            console.log(result.eto_sector_sku_list);

            self.etoSectorSkuInfo = result.eto_sector_sku_list

          })
          .finally(() => {
            self.searching = false;
            eventHub.$emit('loading', false);
          });
      },

      /* region: ETOSectorSku update*/

      updateETOSectorSku(modalData) {
        let self = this;
        let requestData = {
          ftie_id: self.ftieId,
          nre_id: modalData.nreId,
          create_by: self.loginUser,
          username: self.loginUser,
          edit_field: modalData.field,
          input_info: JSON.parse(JSON.stringify(modalData))
        };

        eventHub.$emit('loading', true);
        self.$axios
          .post(self.$root.baseUrl + '/eto-sector-sku/update/', requestData)
          .then(res => {
            let result = res.data;
            console.log("updateETOSectorSku:result");
            //console.log(result);
            let result_obj = null;
            if (res.status === 200) {
              result.save_success = JSON.parse(result.save_success);
              result_obj = result.save_success
            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {

            // reload
            self.reloadEtoSectorSku();
            eventHub.$emit('loading', false);
          });

      },
      /* endregion */



      validate(modalData) {
        let self = this;
        if (modalData !== null) {
          if (_.get(modalData, 'field', '') === 'document') {
            if (_.get(modalData, 'documentToSyncNew', '').length > 800) {

              let text = `The max length of 800 characters in Brochure Link is reached. You typed in ${_.get(modalData, 'documentToSyncNew', '').length} characters`;
              self.$message.warning(text, 'Max Length Reached: Brochure Link');
              return false;
            }
          }
          if (_.get(modalData, 'field', '') === 'remark') {
            if (_.get(modalData, 'remarkToSyncNew', '').length > 300) {

              let text = `The max length of 300 characters in Limitations is reached. You typed in ${_.get(modalData, 'remarkToSyncNew', '').length} characters`;
              self.$message.warning(text, 'Max Length Reached: Limitations');
              return false;
            }
          }

        }
        // self.$message.warning('Please at least chose one product line to be synced with!', 'SFDC Sync Warning');
        return true;
      },
      /* ENDregion: TODO */
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework-sector-sku/ETOSectorSkuPn.vue